"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessService = void 0;
class AccessService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Access({ authorization = 'Bearer <token>', }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Access',
            headers: {
                Authorization: authorization,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.AccessService = AccessService;
